import React from "react";
import { Button, Table } from "antd";
import { DeleteOutlined } from '@ant-design/icons';
import EditableCell from "./EditableCell";
import EditableRow from "./EditableRow";
import { TfiMenuAlt } from "react-icons/tfi";
import EventEmitter from "../../utils/eventEmitter";





const EditableTable = ({name, dataSource, setDataSource, columns, addLine, dependant, option1, option2 }) => {

  const handleDelete = (e, key) => {
    e.preventDefault();
    e.stopPropagation();
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
  };

  const handleSave = (row, form) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    if (form.getFieldValue('description') !== undefined) {
      row['description'] = form.getFieldValue('description');
      row['price'] = form.getFieldValue('price')
    }
    newData.splice(index, 1, {...item, ...row});
    setDataSource(newData);
    if (dependant) EventEmitter.dispatch('to_another_table', item);
  };


  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const handleMenu = () => { 
    EventEmitter.dispatch('show_detailed_operation_modal', true);
  };

  columns[columns.length -1 ]['render'] = (_, record) => 
    <div>
      {name === 'transfer' &&<Button className="border-0 me-2 text-[#189aa0] hover:text-[#189aa0]" onClick={handleMenu} icon={<TfiMenuAlt />}/>}
      <Button className="border-0" danger onClick={(e)=>handleDelete(e, record.key)} icon={<DeleteOutlined />}/>
    </div>

  const mergeColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
        inputType: (col.dataIndex.includes('_id') || col.dataIndex.includes('location')) ? 'select' : 
          (col.dataIndex.includes('quantity')) ? 'number' : 'text',
        options: 
          col.dataIndex === 'product_id' && option2.map(product => ({value: product.id, label: product.name})) ||
          col.dataIndex.includes('location') && option1.map(location => ({value: location.id, label: `${location.name}`})) ||
          col.dataIndex === 'lot_serial_number_id' && []
      }),
    };
  });
  return (
    <div>
      <Table
        components={components}
        rowClassName={() => 'editable-row'}
        bordered
        dataSource={dataSource}
        columns={mergeColumns}
        size="small"
        pagination={false}
      />
      {addLine && <Button onClick={addLine} className="border-0">
        Add a line
      </Button>}
    </div>
  );
};


export default EditableTable;